export default function getBorderColor(reviews: number | undefined): string | undefined {
    if (!reviews)
        return;

    if (reviews >= 1000)
        return '#da7000';
    if (reviews >= 900)
        return '#da5000';
    if (reviews >= 800)
        return '#da3000';
    if (reviews >= 700)
        return '#da1000';
    if (reviews >= 600)
        return '#da0000';

    if (reviews >= 500)
        return '#ba00ba';
    if (reviews >= 400)
        return '#641dff';

    if (reviews >= 300)
        return '#001dda';
    if (reviews >= 200)
        return '#006d94';
    if (reviews >= 100)
        return '#01804b';
}